import { Link } from "react-router-dom";
import InstallApp from "./InstallApp";

const COLUMNS = [
  {
    title: "Jobseekers",
    links: [
      { to: "/jobs", label: "Find jobs", id: "footer-find-jobs" },
      { to: "/courses", label: "Courses & skills", id: "footer-courses" },
      { to: "/resources", label: "Salary & careers resources", id: "footer-resources" },
      { to: "/register", label: "Create an account", id: "footer-create-account" },
      { to: "/register", label: "Job alerts", id: "footer-job-alerts" },
    ],
  },
  {
    title: "Employers",
    links: [
      { to: "/post-a-job", label: "Post a job", id: "footer-post-job" },
      { to: "/platform", label: "Why HiredToday", id: "footer-why-hiredtoday" },
      { to: "/pricing", label: "Pricing", id: "footer-pricing" },
      { to: "/plans", label: "Subscription plans", id: "footer-plans" },
      { to: "/resources#employers", label: "Recruiting advice & international hiring", id: "footer-recruiting-advice" },
      { to: "/contact", label: "Recruiter support", id: "footer-recruiter-support" },
    ],
  },
  {
    title: "Company",
    links: [
      { to: "/contact", label: "Contact us", id: "footer-contact" },
      { to: "/contact", label: "Press & partnerships", id: "footer-press" },
    ],
  },
  {
    title: "Legal",
    links: [
      { to: "/terms", label: "Terms & conditions", id: "footer-terms" },
      { to: "/privacy", label: "Privacy policy", id: "footer-privacy" },
      { to: "/cookies", label: "Cookie policy", id: "footer-cookies" },
      { to: "/accessibility", label: "Accessibility & security", id: "footer-accessibility" },
    ],
  },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-zinc-950 text-zinc-400 mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-x-8 gap-y-10">
          <div className="col-span-2" data-testid="footer-story">
            <p className="font-display text-2xl font-black text-white tracking-tight">
              Hired<span className="text-blue-500">Today</span>
            </p>
            <p className="mt-4 text-sm leading-relaxed max-w-xs">
              HiredToday is a UK job board for employers and jobseekers.
            </p>
          </div>
          {COLUMNS.map((col) => (
            <div key={col.title} className={col.title === "Legal" ? "col-span-2 md:col-span-1" : ""}>
              <p className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500 mb-4">{col.title}</p>
              <ul className="space-y-3 text-sm">
                {col.links.map((l) => (
                  <li key={l.id}>
                    <Link to={l.to} data-testid={l.id} className="hover:text-white transition-colors duration-200">
                      {l.label}
                    </Link>
                  </li>
                ))}
                {col.title === "Company" && (
                  <li><InstallApp /></li>
                )}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-14 pt-8 border-t border-zinc-800 text-center text-xs text-zinc-500">
          <p data-testid="footer-copyright">© {new Date().getFullYear()} HiredToday. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
